const Login = () => import('@/views/user/login') // 用户登录
const Register = () => import('@/views/user/register') // 用户注册
const Setting = () => import('@/views/user/setting') // 设置

export default [
  { path: '/user/login', name: 'login', component: Login, meta: { keepAlive: false, title: '用户登录' } },
  { path: '/reg/:inviteCode', name: 'register', component: Register, meta: { keepAlive: false, title: '注册DSHUI账号' } },
  { path: '/user/setting', name: 'setting', component: Setting, meta: { keepAlive: false, requireAuth: true, title: '设置' } },
]